export default __webpack_public_path__ + "static/media/SpendInStoreBackButton.dbe71cc9.svg";